import shared from 'Services/Shared'

export const refresh = ({ refreshToken }) =>
  shared.apiCall({
    endpoint: '/auth/refresh-token',
    method: 'GET',
    query: { refreshToken },
  })
